module.exports = __webpack_public_path__ + "static/media/T&C20190801.059331fb.pdf";